import styled from 'styled-components';

export const StyledWrapper = styled.div`
  [data-simplebar] {
    margin: 0 -100px;
  }

  @media(max-width: ${props => props.theme.breakpoints.tablet}) {
    [data-simplebar] {
      margin: 0;
    }
  }
`

export const StyledCoffeesContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  padding: 10px 10px 30px;

  .coffee {
    display: flex;

    & + .coffee {
      margin-left: 15px;
    }
  }
`

export const StyledCoffee = styled.div`
  box-shadow: 0 5px 13px rgb(0 0 0 / 20%);
  background: #FFF;
  border: 2px #FFF solid;
  border-radius: ${props => props.theme.borderRadius};
  color: #333;
  display: block;
  font-weight: normal;
  line-height: 1;
  padding: 30px 20px;
  position: relative;
  text-align: center;

  .coffee-box {
    width: 230px;
  }

  .name {
    font-weight: 600;
  }

  .gradient {
    background: var(--gradient-to);
    background: -moz-linear-gradient(45deg, var(--gradient-to) 0%, var(--gradient-mid) 50%, var(--gradient-from) 100%);
    background: -webkit-linear-gradient(45deg, var(--gradient-to) 0%, var(--gradient-mid) 50%, var(--gradient-from) 100%);
    background: linear-gradient(45deg, var(--gradient-to) 0%, var(--gradient-mid) 50%, var(--gradient-from) 100%);
    display: block;
    height: 10px;
    border-radius: 5px;
    margin: 20px 0;
  }

  .items {
    position: relative;
  }

  .background {
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0.2;
    z-index: 1;
  }

  .item {
    position: relative;
    z-index: 2;

    .title {
      text-transform: uppercase;
      font-size: ${props => props.theme.fontSizes.extraSmall};
      opacity: 0.7;
    }
    .value {
      font-weight: 600;
      font-size: 14px;
      margin-top: 5px;
    }

    & + .item {
      margin-top: 20px;
    }
  }

  .actions {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button + button {
      margin-left: 3px;
    }

    .quantity {
      font-size: ${props => props.theme.fontSizes.small};

      strong {
        margin-right: 5px;
      }
    }
  }
`
